var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative","display":"block"}},[_c('canvas',{attrs:{"id":_vm.canvaID}})])}
var staticRenderFns = []

export { render, staticRenderFns }